"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryRow = CategoryRow;
exports.DescriptionItem = DescriptionItem;
exports.DisclaimerItem = DisclaimerItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _density = require("@site/pattern-library-utils/density");
var _index = _interopRequireDefault(require("../../../../elements/other/headline-lockup/index.js"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
/**
 * Local Imports
 */

const TitleContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TitleContainer",
  class: "pl-t8yux8z",
  vars: {
    "t8yux8z-0": [({
      col = 2
    }) => `20vw repeat(${col}, 1fr)`]
  }
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hxrdkn4"
});
const Column = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Column",
  class: "pl-c1ez3deq"
});

/**
 * Category Row.
 *
 * @param {Object} props React props
 * @param {Array}  props.items Column Array
 * @param {String} props.rowGroupTitle Category Text
 * @param {Object} props.ctas Category Row Cta
 * @returns {React.ReactElement} component
 * @public
 */
function CategoryRow({
  items,
  rowGroupTitle,
  ctas
}) {
  return /*#__PURE__*/_react.default.createElement(TitleContainer, {
    role: "row",
    col: items?.length
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "category-title",
    role: "cell"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: rowGroupTitle,
    headlineTag: "h3",
    headlineSize: "h6",
    headlineLineLength: 1.25,
    textAlign: "start",
    actionsLayout: "button-set",
    ctas: ctas
  })), items?.map((column, i) => {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      key: i,
      role: "cell"
    }, column));
  }));
}
CategoryRow.propTypes = {
  rowGroupTitle: _propTypes.default.string,
  items: _propTypes.default.array,
  ctas: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array])
};

/**
 * Description Item.
 *
 * @param {Object} props React props
 * @param {Object} props.text Description text
 * @returns {React.ReactElement} component
 * @public
 */
function DescriptionItem({
  text
}) {
  return /*#__PURE__*/_react.default.createElement(Column, null, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    dataCy: "description",
    text: text
  }));
}
DescriptionItem.propTypes = {
  text: _propTypes.default.string
};

/**
 * Disclaimer Item.
 *
 * @param {Object} props React props
 * @param {Object} props.text Disclaimer text
 * @returns {React.ReactElement} component
 * @public
 */
function DisclaimerItem({
  text
}) {
  return /*#__PURE__*/_react.default.createElement(Column, null, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    dataCy: "disclaimer",
    text: text
  }));
}
DisclaimerItem.propTypes = {
  text: _propTypes.default.string
};